import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  CHANGE_TABS,
  EDIT_PROVIDER_PASSWORD,
  EDIT_PROVIDER_PASSWORD_ERROR,
  EDIT_PROVIDER_PASSWORD_SUCCESS,
  EDIT_PROVIDER_PROFILE_IMAGE,
  EDIT_PROVIDER_PROFILE_IMAGE_ERROR,
  EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS,
  EDIT_PROVIDER_PROFILE_INFO,
  EDIT_PROVIDER_PROFILE_INFO_ERROR,
  EDIT_PROVIDER_PROFILE_INFO_SUCCESS,
  GET_SERVICE_TYPES,
  GET_SERVICE_TYPES_ERROR,
  GET_SERVICE_TYPES_SUCCESS,
  SET_IS_EDIT_SUCCESS,
  SET_IS_IMG_UPLOADED_SUCCESS,
  SET_LOADING,
  SET_PASSWORD_ERROR_MESSAGE,
  SET_TABS,
  SET_ERROR,
  EDIT_PREFERENCES_SETTINGS,
  EDIT_PREFERENCES_SETTINGS_SUCCESS,
  EDIT_PREFERENCES_SETTINGS_ERROR,
  SET_IS_EDIT_PREFERENCES_SUCCESS,
  CLEAR_PHONE_ERROR,
} from './AccountSettingsConstants'
import { getTabId } from '../../utils/common'
import { LOGOUT } from '../auth/AuthConstants'

const initialState = {
  loading: false,
  error: '',
  passwordErrorMessage: '',
  phoneErrorMessage: '',
  serviceTypes: [],
  isEditSuccess: false,
  isEditPasswordSuccess: false,
  isEditPreferencesSuccess: false,
  tabs: null,
  triggerTabId: '',
}

export default function accountSettingsReducer(state = initialState, action = { type: '' }) {
  switch (action.type) {
    case SET_TABS:
      return {
        ...state,
        tabs: [
          { name: 'General', isActive: true },
          { name: 'Licenses', isActive: false },
          { name: 'Security', isActive: false },
          { name: 'Preferences', isActive: false },
        ],
      }
    case CHANGE_TABS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        tabs: state.tabs?.map((t) =>
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          t.name === action.payload ? { ...t, isActive: true } : { ...t, isActive: false },
        ),
      }
    case GET_SERVICE_TYPES:
    case EDIT_PROVIDER_PROFILE_INFO:
    case EDIT_PROVIDER_PROFILE_IMAGE:
    case EDIT_PROVIDER_PASSWORD:
    case EDIT_PREFERENCES_SETTINGS:
      return {
        ...state,
        loading: true,
      }
    case GET_SERVICE_TYPES_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        serviceTypes: action.payload,
        loading: false,
      }
    case SET_IS_EDIT_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isEditSuccess: action.payload,
      }
    case SET_IS_IMG_UPLOADED_SUCCESS:
      return {
        ...state,
      }
    case EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS:
      return {
        ...state,
        isEditSuccess: true,
        loading: false,
      }
    case EDIT_PROVIDER_PROFILE_INFO_SUCCESS:
      const tabId = getTabId()
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isEditSuccess: action.extraData.type === 'withOutImg',
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.extraData.type === 'withImg' && tabId === action.extraData.tabId,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        triggerTabId: action.extraData.tabId,
      }
    case EDIT_PROVIDER_PASSWORD_SUCCESS:
      return {
        ...state,
        isEditPasswordSuccess: true,
        isEditSuccess: true,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        triggerTabId: action.extraData.tabId,
      }
    case EDIT_PREFERENCES_SETTINGS_SUCCESS:
      return {
        ...state,
        isEditPreferencesSuccess: true,
        loading: false,
      }
    case SET_ERROR:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }
    case CLEAR_PHONE_ERROR:
      return {
        ...state,
        phoneErrorMessage: '',
      }
    case SET_LOADING:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.payload,
      }
    case SET_IS_EDIT_PREFERENCES_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isEditPreferencesSuccess: action.payload,
      }
    case SET_PASSWORD_ERROR_MESSAGE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        passwordErrorMessage: action.payload,
      }
    case GET_SERVICE_TYPES_ERROR:
    case EDIT_PROVIDER_PROFILE_INFO_ERROR:
    case EDIT_PROVIDER_PROFILE_IMAGE_ERROR:
    case EDIT_PROVIDER_PASSWORD_ERROR:
    case EDIT_PREFERENCES_SETTINGS_ERROR:
      let message = ''
      let passwordErrorMessageValue = ''
      const allergyNameErrorMessage = ''
      const allergySeverityErrorMessage = ''
      // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
      let defaultServerErrorMessage = ''
      let phoneErrorMessageValue = ''
      const isAllergyAlreadyDeleted = false
      const isNotResetLoading = false
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'CredentialsNotValid':
            passwordErrorMessageValue = getUserFriendlyErrorMessage(errorCodes.CURRENT_PASSWORD_IS_INCORRECT)
            break
          case 'DuplicatePassword':
            passwordErrorMessageValue = getUserFriendlyErrorMessage(errorCodes.PASSWORD_MUST_BE_DIFFERENT)
            break
          case 'Network Error':
            message = getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION)
            break
          case 'ImageNotValid':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.INVALID_FILE_FORMAT, null, '.jpg, .jpeg, .png')
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          case 'PhoneNumberNotUnique':
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            phoneErrorMessageValue = getUserFriendlyErrorMessage(errorCodes.PHONE_NOT_UNIQUE)
            break

          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      console.log('wat')
      return {
        ...state,
        error: message,
        passwordErrorMessage: passwordErrorMessageValue,
        phoneErrorMessage: phoneErrorMessageValue,
        allergyNameError: allergyNameErrorMessage,
        allergySeverityError: allergySeverityErrorMessage,
        loading: isNotResetLoading,
        defaultServerErrorMessage: '',
        isAllergyAddedSuccess: message,
        isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
        isAllergiesRequestFinished: isNotResetLoading,
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    default: {
      return state
    }
  }
}
